module.exports = __webpack_public_path__ + "static/media/irishlifegroup.bbe824af.png";